import styled from 'styled-components';
import { Colors } from '../../constants/StyleConstants';

export const HomePageContainer = styled.div`
  margin: 16px 162px;
`;

export const StImage = styled.div<any>`
  height: 32vh;
  position: relative;
  background-size: cover;
  width: 102%;
  background-repeat: no-repeat;
  margin-left: -12px;
  background-image: ${props => `url(${props.backgroundimage})`};
`;

export const StServicesTitle = styled.p`
  font-size: 18px;
  font-weight: bold;
  margin: 24px 0 16px 0;
`;

export const StCurrentSite = styled.p`
  font-size: 24px;
  font-weight: 600;
  line-height: 29px;
  margin: 0 0 16px 0;
  color: ${Colors.primary};
`;

export const DropDownContainer = styled('div')`
  width: 600px;
`;
